import copy from "clipboard-copy";
import find from "lodash/find";
import React from "react";
import Modal from "../../parts/modal-new";

/** Store review (Apple / Google) logins for a coach's app — see sc-46704. */
const ReviewAccountModal = ({ allUsers, user, api }) => {
  const [result, setResult] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const coach = React.useMemo(
    () => find(allUsers, ["_id", user]),
    [allUsers, user]
  );

  const create = async (type) => {
    setLoading(true);
    // Drop the previous result so stale credentials can't be copied after a failure.
    setResult(null);
    try {
      const response = await api("admin-create-review-account", {
        method: "POST",
        body: { coachId: user, type },
      });
      const body = await response.json();
      setResult({ type, ...body });
    } catch (err) {
      setResult({
        type,
        error: {
          message:
            err?.error?.message || err?.message || "Could not create account.",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal toClear={["user"]} width="750px" title="Store Review Account">
      <div className="body">
        <h3 className="mb-4">
          For {coach.name} - {coach.email}
        </h3>
        <p className="p2 mb-6">
          Fully set up, hidden from the coach and not billed. Creating again
          resets the password.
        </p>
        <div className="flex gap-4 mb-6">
          <button
            type="button"
            data-button-type="outline"
            disabled={loading}
            onClick={() => create("pull")}
          >
            PULL account
          </button>
          <button
            type="button"
            data-button-type="outline"
            disabled={loading}
            onClick={() => create("push")}
          >
            PUSH account
          </button>
        </div>
        {result?.error && (
          <p className="text-red-500">{result.error.message}</p>
        )}
        {result?.email && (
          <div className="Admin-Pass">
            <p className="font-semibold">
              {result.type.toUpperCase()} {result.created ? "created" : "reset"}
            </p>
            <p>Email: {result.email}</p>
            <p>Password: {result.password}</p>
            <button
              type="button"
              data-button-type="primary"
              className="mt-4"
              onClick={() =>
                copy(`Email: ${result.email}\nPassword: ${result.password}`)
              }
            >
              Copy credentials
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ReviewAccountModal;
